import { Dropdown, Form } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";
import { FormError } from "../models/FormError";
import { OrgRole } from "../models/OrgRole";

export interface FormData {
  orgRoleIds: string[];
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  availableOrgRoles?: OrgRole[];
}

const AddRoleToPermitTypeForm = ({ formData, onChange, formErrors, errors, availableOrgRoles }: Props) => {
  const handleChange = (_: any, { name, value }: any) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Dropdown
            required
            error={formErrors.orgRoleIds}
            control={Dropdown}
            name="orgRoleIds"
            fluid
            label="Roles"
            placeholder="Select roles to add..."
            options={availableOrgRoles?.map((r) => ({ key: r.id, text: r.displayName, value: r.id }))}
            value={formData.orgRoleIds ?? []}
            onChange={handleChange}
            multiple
            selection
            search
            noResultsMessage="All org roles are already added to this permit type."
          />
        </Form.Group>
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AddRoleToPermitTypeForm;
